import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { read } from "hooks/useSession.ts";
import { models } from "types/api/viewModels.ts";

const submittingReplacementOrder = read("_submittingReplacementOrder");

export interface OrderDetails {
	jobName?: string;
	poNumber?: string;
	confirmationNumber?: string | null;
	shippingMethod?: boolean;
	shippingDetails?: models["ShipToViewModel"];
	billingDetails?: models["BillToViewModel"] | null;
	labelComments?: string | null;
	isCustomerPickup?: boolean;
}

interface InitialState {
	newAddresses: models["ShipToViewModel"][];
	order: OrderDetails | undefined;
}

export const initialState: InitialState = submittingReplacementOrder
	? { ...submittingReplacementOrder }
	: {
			newAddresses: [],
			order: undefined
		};

const submittingReplacementOrderSlice = createSlice({
	name: "submittingReplacementOrder",
	initialState,
	reducers: {
		addNewAddress: (state, action) => {
			const addressMatchCallback = (shipTo: models["ShipToViewModel"] | null) => {
				return (
					shipTo?.address?.line1 === action.payload?.line1 &&
					shipTo?.address?.line2 === action.payload?.line2 &&
					shipTo?.address?.line3 === action.payload?.line3 &&
					shipTo?.address?.city === action.payload?.city &&
					shipTo?.address?.zip === action.payload?.zip
				);
			};

			if (action.payload && !state.newAddresses?.some(addressMatchCallback)) {
				state.newAddresses?.push(action.payload);
			}

			return state;
		},
		updateOrderDetails: (state, action) => {
			state.order = {
				...state.order,
				jobName: action.payload.jobName,
				poNumber: action.payload.poNumber
			};
		},
		updateConfirmationNumber: (state, action: PayloadAction<string | null>) => {
			state.order = {
				...(state.order ?? {}),
				confirmationNumber: action.payload
			};
		},
		resetOrder: (state) => {
			state.order = undefined;
			state.newAddresses = [];
		},
		updateShippingOrderDetails: (state, action) => {
			state.order = {
				...state.order,
				shippingDetails: action.payload.shippingDetails,
				labelComments: action.payload.labelComments,
				isCustomerPickup: action.payload.isCustomerPickup
			};
		},
		setSelectedBillToAddress: (state, action) => {
			state.order = {
				...state.order,
				billingDetails: action.payload
			};
		}
	}
});

export const submittingReplacementOrderActions = submittingReplacementOrderSlice.actions;
export default submittingReplacementOrderSlice.reducer;
